var giphy_viewer_default = {
  "giphyWrapper": "qXOEc",
  "giphy_player": "Jxh40",
  "playIcon": "_6iDEG",
  "gifRatio": "Ec6vr"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
